import { notification } from 'antd';
import { timestamper } from './timestamper.js';

const putSignature = (data, key) => {
  return new Promise((resolve, reject) => {
    typeof window !== 'undefined' &&
      window?.EIMZOClient.loadKey(
        key,
        (keyId) => {
          window?.EIMZOClient.createPkcs7(
            keyId,
            JSON.stringify(data),
            timestamper,
            (pkcs7) => {
              resolve(pkcs7);
            },
            () => {
              // store.dispatch(showAlert("Вы ввели неправильный пароль ключа"));
              console.log('Вы ввели неправильный пароль ключа');
              // reject("error")
            }
          );
        },
        (error) => {
          // store.dispatch(showAlert("Error"));
          console.log('Error', error);
          notification.error({ message: 'E-imzo error!' });
          // reject("error")
        }
      );
  });
};

export default putSignature;
